// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".docs-landing[data-v-24a6fc57]{max-width:900px}.quick-start-card[data-v-24a6fc57]{cursor:pointer;transition:box-shadow .2s ease}.quick-start-card[data-v-24a6fc57]:hover{box-shadow:0 4px 12px rgba(0,0,0,.1) !important}.feature-card[data-v-24a6fc57]{height:100%}", ""]);
// Exports
module.exports = exports;
